import { render } from "./CourseCategory.vue?vue&type=template&id=2fa33746&scoped=true"
import script from "./CourseCategory.vue?vue&type=script&lang=js"
export * from "./CourseCategory.vue?vue&type=script&lang=js"

import "./CourseCategory.vue?vue&type=style&index=0&id=2fa33746&lang=scss&scoped=true"
import "./CourseCategory.vue?vue&type=style&index=1&id=2fa33746&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fa33746"]])

export default __exports__